// build constants
export const BE_STOCK_LIST_URL = process.env.REACT_APP_BE_STOCK_LIST_URL

// contact constants
export const CONTACT_PHONE = process.env.REACT_APP_CONTACT_PHONE
export const CONTACT_EMAIL = process.env.REACT_APP_CONTACT_EMAIL
export const RAPNET_URL = process.env.REACT_APP_RAPNET_URL

// app constants
export const STOCK_LIST_HEADERS = [
    "stock_no",
    "shape",
    "ct",
    "color",
    "clarity",
    "cut",
    "polish",
    "symm",
    "fluor",
    "depth",
    "table",
    "measurements",
    "lab",
    "report_no",
    "comments",
    "rap",
    "disc",
    "per_ct",
    "total_dollar"
]

export const OPTIONS = {
    color: "ABCDEFGHIJKLMNOPQRSTUVXWYZ".split(""),
    clarity: ["FL", "IF", "VVS1", "VVS2", "VS1", "VS2", "SI1", "SI2", "I1", "I2", "I3"],
    cut: ["EX", "VG", "G", "--"],
    polish: ["EX", "VG", "G"],
    symm: ["EX", "VG", "G"]
}

export const FILTER_LABELS = {
    "ct": "Carat",
    "color": "Color",
    "clarity": "Clarity",
    "cut": "Cut",
    "polish": "Polish",
    "symm": "Symmetry",
}

export const MULTI_SELECT_KEYS = ["color", "clarity", "cut", "polish", "symm"]

export const STOCK_LIST__DISPLAY_HEADERS = [
    ["BOTHRA ENTERPRISES"],
    ["All NET Price, Final"],
    [],
    ["Sr No.",
        "Stock No.",
        "Shape",
        "Ct.",
        "Color",
        "Clarity",
        "Cut",
        "Polish",
        "Symm",
        "Fluor",
        "Depth %",
        "Table %",
        "Measurements",
        "Lab",
        "Report No.",
        "Comments",
        "Rap",
        "Disc %",
        "Per Ct",
        "Total $"]
]
